import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-white rounded-lg p-6\"><div class=\"flex items-center justify-center\"><svg class=\"animate-spin h-5 w-5 text-[#155EEF] mr-3\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg><span class=\"text-gray-900 font-medium\">Loading...</span></div></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "sm:mx-auto sm:w-full sm:max-w-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto h-10 w-auto",
  src: "https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600",
  alt: "Your Company"
}, null, -1)
const _hoisted_7 = { class: "mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900" }
const _hoisted_8 = { class: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Email address", -1)
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "password",
    class: "block text-sm font-medium leading-6 text-gray-900"
  }, "Password"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "font-semibold text-[#155EEF] hover:text-indigo-500"
    }, "Forgot password?")
  ])
], -1)
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
  }, " Sign in ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.userStore.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("h2", _hoisted_7, " Sign in to your account " + _toDisplayString(_ctx.userStore.getUser?.firstName), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("form", {
        class: "space-y-6",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              id: "email",
              name: "email",
              type: "email",
              autocomplete: "email",
              required: "true",
              class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              id: "password",
              name: "password",
              type: "password",
              autocomplete: "current-password",
              required: "true",
              class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _hoisted_13
      ], 32)
    ])
  ]))
}